import React from "react";
import { ReactNode } from "react";

export interface Heading2Props {
  heading?: ReactNode;
  subHeading?: ReactNode;
  className?: string;
}

const Heading2: React.FC<Heading2Props> = ({
  className = "",
  heading = "",
  subHeading,
}) => {
  return (
    <div className={`mb-8 lg:mb-10 text-center sm:text-start ${className}`}>
      <h2 className="text-4xl mb-5 font-semibold">{heading}</h2>
      {subHeading}
    </div>
  );
};

export default Heading2;
